import { render } from "./ClaimEmployeeAutocomplete.vue?vue&type=template&id=a121b97a&scoped=true"
import script from "./ClaimEmployeeAutocomplete.vue?vue&type=script&lang=js"
export * from "./ClaimEmployeeAutocomplete.vue?vue&type=script&lang=js"

import "./ClaimEmployeeAutocomplete.vue?vue&type=style&index=0&id=a121b97a&scoped=true&lang=css"

import exportComponent from "/Users/oscarbout/Code/3birdhrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a121b97a"]])

export default __exports__